export default "__VITE_ASSET__DeXQvjdN__"